var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0v4h4zm1 8H5v2h6zM9 4V0H3.5A1.5 1.5 0 0 0 2 1.5v13A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5V5h-3.972A1 1 0 0 1 9 4zM4 2.25A.252.252 0 0 1 4.25 2h2.5a.251.251 0 0 1 .25.25v.5a.251.251 0 0 1-.25.25h-2.5A.252.252 0 0 1 4 2.75zm0 2A.251.251 0 0 1 4.25 4h2.5a.251.251 0 0 1 .25.25v.5a.251.251 0 0 1-.25.25h-2.5A.251.251 0 0 1 4 4.75zm8 9.5a.252.252 0 0 1-.25.25h-2.5a.251.251 0 0 1-.25-.25v-.5a.252.252 0 0 1 .25-.25h2.5a.252.252 0 0 1 .25.25zm0-6.25v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIcon);
export default __webpack_public_path__ + "static/media/bill-icon.ef0cfa1d2f7b600061dd5c95f75352fa.svg";
export { ForwardRef as ReactComponent };